import React, { useEffect, useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { familyDetailSchema } from "./ValidationSchema";
import {
  getFamilyValue,
  getFamilyType,
  getFamilyStatus,
  submitLifeStyleFamily,
} from "../asiosConfig";
import { Grid, Button, MenuItem, Select, CircularProgress } from "@mui/material";

import CommonPopup from "./CommonPopup";

const RegisterFamilyStep = ({ onNext, registrationData }) => {
  const [familyValues, setFamilyValues] = useState([]);
  const [familyTypes, setFamilyTypes] = useState([]);
  const [familyStatuses, setFamilyStatuses] = useState([]);

  const siblingCountOptions = [0, 1, 2, 3, 4, 5];

  const [popup, setPopup] = useState({
    open: false,
    type: "", // "success" | "error"
    message: "",
  });

  const initialValues = {
    familyValue: "",
    familyStatus: "",
    familyType: "",
    fatherName: "",
    motherName: "",
    fatherProfessions: "",
    motherProfession: "",
    marriedBrothers: "",
    unMarriedBrothers: "",
    marriedSister: "",
    unMarriedSister: "",
    familyOrigin: "",
    aboutFamily: "",
    user_id: registrationData?.user_id || localStorage.getItem("user"),
    token: registrationData?.token || localStorage.getItem("token"),
  };

  //     const handlePopupClose = () => {
  //   setPopup({ open: false, type: "", message: "" });

  //   if (popup.type === "success") {
  //     onNext(5); // Go to Photo Upload step
  //   }
  // };

  const handlePopupClose = () => {
    setPopup({ open: false, type: "", message: "" });

    if (popup.type === "success") {
      localStorage.setItem("register_current_step", 5);
      onNext(5);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [valRes, typRes, statRes] = await Promise.all([
          getFamilyValue(),
          getFamilyType(),
          getFamilyStatus(),
        ]);
        setFamilyValues(valRes.data.data || []);
        setFamilyTypes(typRes.data.data || []);
        setFamilyStatuses(statRes.data.data || []);
      } catch (error) {
        // toast.error('Failed to fetch data');
        setPopup({
          open: true,
          type: "error",
          message: "Failed to fetch data",
        });
      }
    };
    fetchData();
  }, []);

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const response = await submitLifeStyleFamily(values);

      if (response.status === 200 || response.status === 201) {
        setPopup({
          open: true,
          type: "success",
          message: "Family details saved successfully",
        });
      } else {
        setPopup({
          open: true,
          type: "error",
          message: response.data.message || "Failed to save",
        });
      }
    } catch (error) {
      // setPopupMessage(error.response?.data?.message || 'Error saving details');
      // setPopupOpen(true);

      setPopup({
        open: true,
        type: "error",
        message: error.response?.data?.message || "Error saving details",
      });
    } finally {
      setSubmitting(false);
    }
  };

  const InputBox = ({
    name,
    value,
    onChange,
    placeholder,
    select,
    children,
    type = "text",
  }) => (
    <div
      style={{
        borderRadius: "10px",
        backgroundColor: "#f5fcfe",
        border: "1px solid #d4d4d4",
        height: "40px",
        display: "flex",
        alignItems: "center",
        padding: "0 15px",
        fontFamily: "Montserrat",
      }}
    >
      {select ? (
        <Select
          name={name}
          value={value}
          onChange={onChange}
          displayEmpty
          variant="standard"
          disableUnderline
          fullWidth
          MenuProps={{
            PaperProps: {
              style: {
                backgroundColor: "#f5fcfe",
                borderRadius: "10px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              },
            },
          }}
          sx={{
            fontSize: "15px",
            color: "#333",
            fontFamily: "Montserrat, sans-serif",
            "& .MuiSelect-select": {
              padding: "0 !important",
              fontFamily: "Montserrat",
            },
          }}
        >
          <MenuItem value="" disabled>
            {placeholder}
          </MenuItem>
          {children}
        </Select>
      ) : (
        <input
          name={name}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          style={{
            width: "100%",
            height: "100%",
            border: "none",
            outline: "none",
            background: "transparent",
            fontSize: "15px",
            fontWeight: 500,
            color: "#333",
          }}
        />
      )}
    </div>
  );

  return (
    <div
      style={{
        flex: "1 1 500px",
        // padding: "30px 40px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
        width: "100%",
      }}
    >
      {/* SKIP BUTTON */}
      <Button
        onClick={() => {
          localStorage.setItem("register_current_step", 5);
          onNext(5);
        }}
        sx={{
          position: "absolute", //  put it at top-right
          // top: "-72px",
          // right: "41px",

          top:
            window.innerWidth <= 500
              ? "-38px"
              : window.innerWidth <= 768
              ? "-45px"
              : "-46px",

          // right: window.innerWidth <= 500 ? "10px" :
          //     window.innerWidth <= 768 ? "42px" :
          //     window.innerWidth <= 1024 ? "184px" : "3px",

          right: {
            xs: "5px", // <=600
            sm: "55px", // 600–900
            md: "184px", // 900–1200
            lg: "3px", // >=1200
          },

          borderRadius: "40px",
          padding:
            window.innerWidth <= 500
              ? "6px 45px"
              : window.innerWidth <= 768
              ? "6px 45px"
              : "6px 45px",
          background: "linear-gradient(90deg, #f78c25, #ff3c3c)",
          color: "#fff",
          fontWeight: 600,
          fontSize: "13px", // smaller font
          textTransform: "none",
          fontFamily: "Montserrat",
          boxShadow: "0 4px 8px rgba(255,60,60,0.3)",
          zIndex: 10,
        }}
      >
        Skip
      </Button>
      <Formik
        initialValues={initialValues}
        validationSchema={familyDetailSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting, values, handleChange }) => (
          <Form
            style={{
              width: "100%",
              maxWidth: "480px",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              textAlign: "left",
              fontFamily: "Montserrat",
            }}
          >

            <Grid container spacing={2}>
              {/* Family Value */}
              <Grid item xs={12} sm={6}>
                <InputBox
                  name="familyValue"
                  value={values.familyValue}
                  onChange={handleChange}
                  placeholder="Family Value"
                  select
                >
                  {familyValues.map((val) => (
                    <MenuItem
                      key={val.id}
                      value={val.id}
                      sx={{
                        fontFamily: "Montserrat",
                        fontSize: "16px",
                        color: "#171616ff",
                      }}
                    >
                      {val.name}
                    </MenuItem>
                  ))}
                </InputBox>
                <ErrorMessage
                  name="familyValue"
                  component="div"
                  style={{ color: "red", fontSize: "12px", marginTop: "2px" }}
                />
              </Grid>

              {/* Family Status */}
              <Grid item xs={12} sm={6}>
                <InputBox
                  name="familyStatus"
                  value={values.familyStatus}
                  onChange={handleChange}
                  placeholder="Family Status"
                  select
                >
                  {familyStatuses.map((stat) => (
                    <MenuItem
                      key={stat.id}
                      value={stat.id}
                      sx={{
                        fontFamily: "Montserrat",
                        fontSize: "16px",
                        color: "#171616ff",
                      }}
                    >
                      {stat.name}
                    </MenuItem>
                  ))}
                </InputBox>
                <ErrorMessage
                  name="familyStatus"
                  component="div"
                  style={{ color: "red", fontSize: "12px", marginTop: "2px" }}
                />
              </Grid>
            </Grid>

            <InputBox
              name="familyType"
              value={values.familyType}
              onChange={handleChange}
              placeholder="Family Type"
              select
            >
              {familyTypes.map((typ) => (
                <MenuItem
                  key={typ.id}
                  value={typ.id}
                  sx={{
                    fontFamily: "Montserrat",
                    fontSize: "16px",
                    color: "#171616ff",
                  }}
                >
                  {typ.name}
                </MenuItem>
              ))}
            </InputBox>
            <ErrorMessage
              name="familyType"
              component="div"
              style={{ color: "red", fontSize: "12px", marginBottom: "2px" }}
            />

            <InputBox
              name="fatherName"
              value={values.fatherName}
              onChange={handleChange}
              placeholder="Father’s Name"
            />
            <ErrorMessage
              name="fatherName"
              component="div"
              style={{ color: "red", fontSize: "12px", marginBottom: "2px" }}
            />

            <InputBox
              name="motherName"
              value={values.motherName}
              onChange={handleChange}
              placeholder="Mother’s Name"
            />
            <ErrorMessage
              name="motherName"
              component="div"
              style={{ color: "red", fontSize: "12px", marginBottom: "2px" }}
            />

            <InputBox
              name="fatherProfessions"
              value={values.fatherProfessions}
              onChange={handleChange}
              placeholder="Father’s Profession"
            />
            <ErrorMessage
              name="fatherProfessions"
              component="div"
              style={{ color: "red", fontSize: "12px", marginBottom: "2px" }}
            />

            <InputBox
              name="motherProfession"
              value={values.motherProfession}
              onChange={handleChange}
              placeholder="Mother’s Profession"
            />
            <ErrorMessage
              name="motherProfession"
              component="div"
              style={{ color: "red", fontSize: "12px", marginBottom: "2px" }}
            />

            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                {/* <InputBox
                                    name="marriedBrothers"
                                    value={values.marriedBrothers}
                                    onChange={handleChange}
                                    placeholder="Married Brothers"
                                    type="number"
                                /> */}

                <InputBox
                  name="marriedBrothers"
                  value={values.marriedBrothers}
                  onChange={handleChange}
                  placeholder="Married Brothers"
                  select
                >
                  {siblingCountOptions.map((count) => (
                    <MenuItem key={count} value={count}>
                      {count}
                    </MenuItem>
                  ))}
                </InputBox>

                <ErrorMessage
                  name="marriedBrothers"
                  component="div"
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginBottom: "2px",
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                {/* <InputBox
                  name="unMarriedBrothers"
                  value={values.unMarriedBrothers}
                  onChange={handleChange}
                  placeholder="Unmarried Brothers"
                  type="number"
                /> */}
                <InputBox
                  name="unMarriedBrothers"
                  value={values.unMarriedBrothers}
                  onChange={handleChange}
                  placeholder="Unmarried Brothers"
                  select
                >
                  {siblingCountOptions.map((count) => (
                    <MenuItem key={count} value={count}>
                      {count}
                    </MenuItem>
                  ))}
                </InputBox>

                <ErrorMessage
                  name="unMarriedBrothers"
                  component="div"
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginBottom: "2px",
                  }}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                {/* <InputBox
                  name="marriedSister"
                  value={values.marriedSister}
                  onChange={handleChange}
                  placeholder="Married Sisters"
                  type="number"
                /> */}

                <InputBox
                  name="unMarriedSister"
                  value={values.unMarriedSister}
                  onChange={handleChange}
                  placeholder="Unmarried Sisters"
                  select
                >
                  {siblingCountOptions.map((count) => (
                    <MenuItem key={count} value={count}>
                      {count}
                    </MenuItem>
                  ))}
                </InputBox>

                <ErrorMessage
                  name="marriedSister"
                  component="div"
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginBottom: "2px",
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                {/* <InputBox
                  name="unMarriedSister"
                  value={values.unMarriedSister}
                  onChange={handleChange}
                  placeholder="Unmarried Sisters"
                  type="number"
                /> */}

                <InputBox
                  name="marriedSister"
                  value={values.marriedSister}
                  onChange={handleChange}
                  placeholder="Married Sisters"
                  select
                >
                  {siblingCountOptions.map((count) => (
                    <MenuItem key={count} value={count}>
                      {count}
                    </MenuItem>
                  ))}
                </InputBox>

                <ErrorMessage
                  name="unMarriedSister"
                  component="div"
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginBottom: "2px",
                  }}
                />
              </Grid>
            </Grid>

            <InputBox
              name="familyOrigin"
              value={values.familyOrigin}
              onChange={handleChange}
              placeholder="Family Native Place"
            />
            <ErrorMessage
              name="familyOrigin"
              component="div"
              style={{ color: "red", fontSize: "12px", marginBottom: "2px" }}
            />

            <InputBox
              name="aboutFamily"
              value={values.aboutFamily}
              onChange={handleChange}
              placeholder="About Family"
            />
            <ErrorMessage
              name="aboutFamily"
              component="div"
              style={{ color: "red", fontSize: "12px", marginBottom: "2px" }}
            />

            <Button
              type="submit"
              variant="contained"
              disabled={isSubmitting}
              style={{
                borderRadius: "50px",
                background:
                  "linear-gradient(rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.22)), linear-gradient(90deg, #f78c25, #ff3c3c)",
                color: "#fff",
                fontWeight: 600,
                fontSize: "16px",
                height: "49px",
                textTransform: "none",
                fontFamily: "Montserrat",
                boxShadow: "0 4px 8px rgba(255,60,60,0.3)",
                gap: "10px",
              }}
            >
              {isSubmitting && (
                <CircularProgress
                  size={20}
                  thickness={5}
                  sx={{ color: "#fff" }}
                />
              )}

              {isSubmitting ? "Saving..." : "Next"}
            </Button>
          </Form>
        )}
      </Formik>

      <CommonPopup
        open={popup.open}
        type={popup.type}
        message={popup.message}
        onClose={handlePopupClose}
      />
    </div>
  );
};

export default RegisterFamilyStep;
